import { LoanDocumentEnum } from './enums/LoanDocumentEnum';
import { LoanDocumentType } from './types/LoanDocumentType';
import { UploadedLoanDocumentType } from './types/UploadedLoanDocumentType';
import useNewLoanDocumentStore from './useNewLoanDocumentStore';

export type DocumentStoreForType = {
  addDocuments(file: File[]): void;
  clearPreview(document: LoanDocumentType): void;
  confirm(): void;
  hasProvidedDocuments: boolean;
  removeDocument(document: LoanDocumentType): void;
  isDuplicateFile(file: File): boolean;
  isWorkflowCompleted: boolean;
  isWorkflowStarted: boolean;
  loadDocuments(): void;
  percent: number;
  providedDocuments: LoanDocumentType[];
  reset(): void;
  uploadedDocuments: UploadedLoanDocumentType[];
};

export const useLoanDocumentStoreForType = (
  type: LoanDocumentEnum,
): DocumentStoreForType => {
  const {
    addGAPDocuments,
    addRICDocuments,
    addVSCDocuments,
    clearPreview,
    computed: {
      hasProvidedGAPDocuments,
      hasProvidedRICDocuments,
      hasProvidedVSCDocuments,
      percent,
      providedGAPDocuments,
      providedRICDocuments,
      providedVSCDocuments,
    },
    confirmGAPDocuments,
    confirmRICDocuments,
    confirmVSCDocuments,
    isDuplicateGAPFile,
    isDuplicateRICFile,
    isDuplicateVSCFile,
    isWorkflowCompleted,
    isWorkflowStarted,
    loadGAPDocuments,
    loadRICDocuments,
    loadVSCDocuments,
    removeDocument,
    resetGAPDocuments,
    resetRICDocuments,
    resetVSCDocuments,
    uploadedGAPDocuments,
    uploadedRICDocuments,
    uploadedVSCDocuments,
  } = useNewLoanDocumentStore();

  switch (type) {
    case LoanDocumentEnum.SERVICE_CONTRACT:
      return {
        addDocuments: addVSCDocuments,
        clearPreview,
        confirm: confirmVSCDocuments,
        hasProvidedDocuments: hasProvidedVSCDocuments,
        isDuplicateFile: isDuplicateVSCFile,
        isWorkflowCompleted,
        isWorkflowStarted,
        loadDocuments: loadVSCDocuments,
        percent,
        providedDocuments: providedVSCDocuments,
        removeDocument,
        reset: resetVSCDocuments,
        uploadedDocuments: uploadedVSCDocuments,
      };
    case LoanDocumentEnum.GAP_CONTRACT:
      return {
        addDocuments: addGAPDocuments,
        clearPreview,
        confirm: confirmGAPDocuments,
        hasProvidedDocuments: hasProvidedGAPDocuments,
        isDuplicateFile: isDuplicateGAPFile,
        isWorkflowCompleted,
        isWorkflowStarted,
        loadDocuments: loadGAPDocuments,
        percent,
        providedDocuments: providedGAPDocuments,
        removeDocument,
        reset: resetGAPDocuments,
        uploadedDocuments: uploadedGAPDocuments,
      };
    case LoanDocumentEnum.RIC:
      return {
        addDocuments: addRICDocuments,
        clearPreview,
        confirm: confirmRICDocuments,
        hasProvidedDocuments: hasProvidedRICDocuments,
        isDuplicateFile: isDuplicateRICFile,
        isWorkflowCompleted,
        isWorkflowStarted,
        loadDocuments: loadRICDocuments,
        percent,
        providedDocuments: providedRICDocuments,
        removeDocument,
        reset: resetRICDocuments,
        uploadedDocuments: uploadedRICDocuments,
      };
    default:
      throw new Error(`Invalid document type: ${type}`);
  }
};
